import { render, staticRenderFns } from "./add_pointperson.vue?vue&type=template&id=f87237a6&scoped=true"
import script from "./add_pointperson.vue?vue&type=script&lang=js"
export * from "./add_pointperson.vue?vue&type=script&lang=js"
import style0 from "./add_pointperson.vue?vue&type=style&index=0&id=f87237a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87237a6",
  null
  
)

export default component.exports